/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolToolsLevelIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-tools-level"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.33 17.32Q3.2 17.32 2.44 16.56Q1.68 15.8 1.68 14.68L1.68 9.32Q1.68 8.2 2.44 7.44Q3.2 6.67 4.33 6.67L19.68 6.67Q20.8 6.67 21.56 7.44Q22.32 8.2 22.32 9.32L22.32 14.68Q22.32 15.8 21.56 16.56Q20.8 17.32 19.68 17.32ZM9.5 11.03L10.68 11.03L10.68 9.32L9.5 9.32Q9.15 9.32 8.9 9.57Q8.65 9.82 8.65 10.18Q8.65 10.53 8.9 10.78Q9.15 11.03 9.5 11.03ZM13.32 11.03L14.5 11.03Q14.85 11.03 15.1 10.78Q15.35 10.53 15.35 10.18Q15.35 9.82 15.1 9.57Q14.85 9.32 14.5 9.32L13.32 9.32Z" fill={color} />
    </svg>
  );
}
